import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PanelComponent, Register } from '@xanadu/core';
import { Role } from '@xanadu/model';
import { RoleCache } from '@xanadu/cache';

@Component({
    selector: 'app-role-panel',
    templateUrl: './role-panel.component.html',
    styleUrls: ['./role-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('role-panel')
export class RolePanelComponent extends PanelComponent<Role> {
    private readonly roleCache = inject(RoleCache);

    private tabRole = { caption: 'Role', active: true, hidden: false };

    typeMeta = { id: 'dataType', name: 'Data Type', info: 'Permission to manage data type.' };
    schemaMeta = { id: 'schema', name: 'Schema', info: 'Permission to manage schema.' };
    contentMeta = { id: 'content', name: 'Content', info: 'Permission to manage content.' };
    importMeta = { id: 'import', name: 'Import', info: 'Permission to manage import.' };
    securityMeta = { id: 'security', name: 'Security', info: 'Permission to manage security.' };

    protected override get nodeType(): string | undefined {
        return 'role';
    }

    protected override setup(role: Role): void {
        super.setup(role);

        this.tabs = [
            this.tabRole
        ];
        this.tabSelected = this.tabRole;
    }

    protected override load(role: Role, form: any): string | undefined {
        super.load(role, form);

        role.permit = form;
        return;
    }

    protected override refresh(role: Role): void {
        super.refresh(role);

        this.roleCache.update();
    }
}
